import { EnefApiService } from "../services/EnefApiService";

const api = new EnefApiService();

export const getUserCourses = async () =>
  await api.makeHttpRequest({ url: '/usuario/perfil/cursos' });
